import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { AiFilters, Row, TextButton, Typography } from 'seagull';
import { ExclamationMark } from 'seagull/icons/essentials';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import styles from './DraftsAiSearch.module.scss';
import { hasHiddenColumnFilter } from './DraftsAiSearch.utils';
import { DraftsAiSearchChips } from './DraftsAiSearchChips/DraftsAiSearchChips';
import { DraftsAiSearchInput } from './DraftsAiSearchInput/DraftsAiSearchInput';
import { useDraftsAiSearchErrorToast } from './hooks/useDraftsAiSearchErrorToast';
import { useDraftsAiSearchStore } from './hooks/useDraftsAiSearchStore';
export const GetDraftsAiSearchTID = (parentTestId)=>getTestIds(parentTestId);
export const DraftsAiSearch = (param)=>{
    let { testId, placeholder, totalMatchCount, totalDraftCount, isInlineEditMode = false, initialQuery, onSubstringChange, onEnableAdvancedEdit, searchRowActions } = param;
    const { DraftsAiSearchTestIds } = useMemo(()=>GetDraftsAiSearchTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const filter = useDraftsAiSearchStore((s)=>s.filter);
    const clearFilter = useDraftsAiSearchStore((s)=>s.clearFilter);
    useDraftsAiSearchErrorToast(DraftsAiSearchTestIds.ErrorToast());
    const hasActiveFilter = filter != null;
    const showSettingsBanner = hasHiddenColumnFilter(filter) && !isInlineEditMode;
    const clearSearch = ()=>{
        clearFilter();
        onSubstringChange === null || onSubstringChange === void 0 ? void 0 : onSubstringChange('');
    };
    const countAndClear = /*#__PURE__*/ _jsxs(Row, {
        alignItems: "center",
        gap: 4,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                testId: DraftsAiSearchTestIds.Count(),
                skin: "secondary",
                variant: "paragraph2",
                children: t.searchResultCount({
                    matches: totalMatchCount,
                    total: totalDraftCount
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                skin: "secondary",
                variant: "paragraph2",
                children: "•"
            }),
            /*#__PURE__*/ _jsx(TextButton, {
                testId: DraftsAiSearchTestIds.ClearButton(),
                bi: {
                    name: 'drafts_ai_search_clear'
                },
                onClick: clearSearch,
                variant: "paragraph2",
                underline: "none",
                weight: "normal",
                children: t.clearButton()
            })
        ]
    });
    return /*#__PURE__*/ _jsx(AiFilters, {
        testId: DraftsAiSearchTestIds.Root(),
        input: /*#__PURE__*/ _jsx(DraftsAiSearchInput, {
            testId: DraftsAiSearchTestIds.Input(),
            placeholder: placeholder,
            initialQuery: initialQuery,
            onQueryChange: onSubstringChange
        }),
        searchRowActions: searchRowActions,
        chips: hasActiveFilter && /*#__PURE__*/ _jsx(DraftsAiSearchChips, {
            testId: DraftsAiSearchTestIds.Chips(),
            trailing: countAndClear,
            isInlineEditMode: isInlineEditMode
        }),
        banner: showSettingsBanner && /*#__PURE__*/ _jsxs(Row, {
            testId: DraftsAiSearchTestIds.SettingsBanner(),
            gap: 16,
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(ExclamationMark, {
                    size: 24,
                    className: styles.calloutIcon
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    children: t.settingsFiltersPending()
                }),
                /*#__PURE__*/ _jsx(TextButton, {
                    testId: DraftsAiSearchTestIds.EnableAdvancedEdit(),
                    bi: {
                        name: 'drafts_ai_search_enable_advanced_edit'
                    },
                    onClick: onEnableAdvancedEdit,
                    variant: "paragraph2",
                    underline: "none",
                    weight: "normal",
                    children: t.enableAdvancedEdit()
                })
            ]
        })
    });
};
